<template>
  <article>
    <section
      v-for="section in content"
      :key="section.id"
      class="grid grid-cols-12 gap-4"
    >
      <div
        v-for="col in section.columns"
        :key="col.id"
        class="column col-span-12"
        :class="'lg:col-span-' + col.span"
      >
        <div v-for="block in col.blocks" :key="block.id" class="blocks">
          <div class="block mb-4" :class="'block-type-' + block.type">
                  <template v-if="block.type === 'heading'">
                        <h1 class="max-w-prose" v-html="block.text"></h1>
                  </template>
                  <template v-if="block.type === 'text'">
                        <div class="space-y-4 max-w-prose" v-html="block.text" />
                  </template>
                  <template v-if="block.type === 'image'">
                        <img
                        data-size="auto"
                        :data-src="block.thumb"
                        :data-srcset="block.srcset"
                        class="lazyload w-full"
                        />
                        <figcaption class="text-sm" v-if="block.caption">
                        Caption
                        </figcaption>
                  </template>
                  <template v-if="block.type === 'gallery'">
                        <div class="w-full flex overflow-x-auto no-scrollbar">
                        <div
                              v-for="image in block.images"
                              :key="image.id"
                              class="relative flex-shrink-0 flex-grow-0 h-gallery"
                        >
                              <img
                              data-size="auto"
                              :data-src="image.thumb"
                              :data-srcset="image.srcset"
                              class="lazyload h-full max-w-none"
                              />
                              <figcaption class="text-sm" v-if="image.caption">
                              Caption
                              </figcaption>
                        </div>
                        </div>
                  </template>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import "lazysizes";
export default {
  props: {
    content: Array,
  },
};
</script>
